import { useRef, useEffect } from 'react';

/**
 * Custom hook for performance monitoring
 * @returns {Object} Render count reference and logging functions
 */
export const usePerformanceMonitoring = () => {
  const renderCountRef = useRef({
    signage: 0,
    markers: 0,
    gridConfig: 0,
    transformedComponents: 0,
    mainComponents: 0,
    sideComponents: 0
  });

  // Single consolidated render statistics log (optimized frequency)
  useEffect(() => {
    const logTimer = setInterval(() => {
      const stats = renderCountRef.current;
      const totalRenders = stats.signage + stats.mainComponents + stats.sideComponents;
      
      // Only log if there's significant activity
      if (totalRenders > 0) {
        console.log('📊 Performance Stats:', {
          'Total Renders': totalRenders,
          'Markers Updates': stats.markers,
          'Grid Recalcs': stats.gridConfig
        });
      }
    }, 30000); // Reduced frequency to 30 seconds
    
    return () => clearInterval(logTimer);
  }, []);

  const incrementRenderCount = (type) => {
    renderCountRef.current[type] += 1;
  };

  const trackMainComponentRender = () => {
    renderCountRef.current.signage += 1;
  };

  return {
    renderCountRef,
    incrementRenderCount,
    trackMainComponentRender
  };
};
